import { diContainer } from '../../service-setup/diContainer';
import serviceNames from '~setup/CommunicationsService';
import { ProductNotifyMeRepository } from '../repositories/ProductNotifyMeRepository';
import { emit, events } from '@estee/elc-service-bus';

export class ProductNotifyMeRequestUseCase {
    private context?: string;
    private skuId: string;
    private email: string;
    private subscriptionType: string;
    private skuBaseId: string;

    private productNotifyMeRepository: ProductNotifyMeRepository;

    constructor(spec: {
        context?: string;
        skuId: string;
        skuBaseId: string;
        email: string;
        subscriptionType: string;
    }) {
        this.context = spec.context;
        this.skuId = spec.skuId;
        this.email = spec.email;
        this.subscriptionType = spec.subscriptionType;
        this.skuBaseId = spec.skuBaseId;

        this.productNotifyMeRepository = diContainer.get(serviceNames.productNotifyMeRepository);
    }

    public execute = async () => {
        const { context, skuId, email, subscriptionType, skuBaseId } = this;

        let error = false;

        try {
            await this.productNotifyMeRepository.subscribeToBackInStockNotification({
                skuId,
                email,
                subscriptionType
            });
        } catch (err) {
            error = true;
        }

        if (!error) {
            emit(events.PRODUCT_NOTIFY_ME_REQUEST_SUCCESS, {
                context,
                skuId,
                email,
                subscriptionType,
                skuBaseId
            });
        } else {
            emit(events.PRODUCT_NOTIFY_ME_REQUEST_FAILURE, {
                context,
                skuId,
                email,
                subscriptionType,
                skuBaseId
            });
        }
    };
}
